import clsx from "clsx";
import { useState } from "react";

import styles from "./OutletMenuHeader.module.scss";
import SpotlightText from "../support/SpotlightText";
import Button from "../support/Button";

function OutletMenuHeader() {
  const [selectedGroupIndex, setSelectedGroupIndex] = useState(0);
  const [selectedSubGroupIndex, setSelectedSubGroupIndex] = useState(0);
  // Food Product Menu Groups array
  const groups = ["Beverages", "Appetizers", "Main Course", "Desserts"];
  // Sub-Groups array
  const subGroups = [
    ["Hot", "Cold"],
    ["Veg", "Non-Veg"],
    ["Veg", "Non-Veg"],
    ["Veg", "Non-Veg"],
  ];

  return (
    <div className={styles.container}>
      <hr />
      <div className={clsx(styles.wrapper, styles.groupWrapper)}>
        {groups.map((group, index) => (
          <SpotlightText
            key={index}
            text={group}
            onClick={() => {
              setSelectedGroupIndex(index);
              setSelectedSubGroupIndex(0);
            }}
            active={selectedGroupIndex === index}
            className={clsx({ [styles.active]: selectedGroupIndex === index })}
          />
        ))}
      </div>
      <hr />
      {subGroups && subGroups?.length > 0 && (
        <>
          <div
            id="sub-menus"
            className={clsx(styles.wrapper, styles.subGroupWrapper)}
          >
            {subGroups[selectedGroupIndex].map((subGroup, index) => (
              <Button
                key={index}
                variant="secondary"
                onClick={() => setSelectedSubGroupIndex(index)}
                className={clsx({
                  [styles.selectedButton]: selectedSubGroupIndex === index,
                })}
                id={`sub-menu-${index}`}
              >
                {subGroup}
              </Button>
            ))}
          </div>
          <hr />
        </>
      )}
    </div>
  );
}

export default OutletMenuHeader;
